export default "__VITE_ASSET__DXkkRp$S__"